import {
  EnumDeviceType,
  ENUMDEVICETYPE_OPTION,
} from "../../../generated/enums";
import { BadgeFilter } from "../../common/BadgeFilter";
import { DeviceTypeBadge } from "./DeviceTypeBadge";

type DeviceTypeFilterProps = {
  value: EnumDeviceType | "";
  onChange: (value: EnumDeviceType | "") => void;
};

export const DeviceTypeFilter = ({
  value,
  onChange,
}: DeviceTypeFilterProps) => {
  return (
    <BadgeFilter
      value={value}
      onChange={onChange}
      options={ENUMDEVICETYPE_OPTION}
      renderBadge={(type) => <DeviceTypeBadge type={type} />}
    />
  );
};
